export default {
  fi: {
    SideBar: {
      home: 'Ajoneuvohaku',
      settings: 'Asetukset',
      partnerSettings: 'Yritys',
      logOut: 'Kirjaudu ulos',
      team: 'Tiimi',
      serviceCallSection: 'Huoltokutsuliittymä',
      serviceCallApply: 'Huoltokutsuliittymä',
      serviceCallDashboard: 'Dashboard',
      serviceCallCustomers: 'Asiakasyritykset',
      feedback: 'Anna palautetta',
    },
  },
};
